import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import MultiSelect from '../../../../../Elements/MultiSelect';
import SingleSelect from '../../../../../Elements/SingleSelect';
import isArray from 'lodash/isArray';
var emptyValue = [];
var SelectFilter = function (_a) {
    var onChange = _a.onChange, isMulti = _a.isMulti, value = _a.value, options = _a.options, checkAllButton = _a.checkAllButton;
    var handleOnMultiChange = useCallback(function (options) {
        onChange === null || onChange === void 0 ? void 0 : onChange(!isArray(options) || !(options === null || options === void 0 ? void 0 : options.length) ? null : options.map(function (option) { return option.value; }));
    }, [onChange]);
    if (isMulti) {
        return (_jsx(MultiSelect, { maxMenuHeight: 250, onChange: handleOnMultiChange, value: value || emptyValue, options: options, checkAllButton: checkAllButton, style: "gridFilter" }));
    }
    else {
        return _jsx(SingleSelect, { maxMenuHeight: 250, onChange: onChange, value: value, options: options, style: "gridFilter" });
    }
};
export default SelectFilter;
